(() => {
  const selector = '[data-goodr-press]';

  const reveal = (section) => {
    section.classList.add('is-in-view');
  };

  const init = (root = document) => {
    root.querySelectorAll(selector).forEach((section) => {
      if (section.dataset.goodrPressReady === 'true') return;
      section.dataset.goodrPressReady = 'true';

      if (
        !section.classList.contains('goodr-press--animate') ||
        !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        reveal(section);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          reveal(section);
          observer.disconnect();
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );

      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
